import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import Layout from '../components/Layout'

interface Lead {
  id: string; company_name: string | null; contact_name: string | null; contact_title: string | null
  email: string | null; phone: string | null; city: string | null; industry: string | null
  status: string | null; score: number | null; source: string | null
}

const STATUSES = ['nouveau', 'contacté', 'qualifié', 'proposition', 'client', 'perdu']

export default function Leads() {
  const [leads, setLeads] = useState<Lead[]>([])
  const [loading, setLoading] = useState(true)
  const [q, setQ] = useState('')
  const [form, setForm] = useState({ company_name: '', contact_name: '', email: '', phone: '' })

  async function load() {
    const { data } = await supabase.from('leads')
      .select('id,company_name,contact_name,contact_title,email,phone,city,industry,status,score,source')
      .order('score', { ascending: false, nullsFirst: false }).order('created_at', { ascending: false }).limit(200)
    setLeads((data as any) || []); setLoading(false)
  }
  useEffect(() => { load() }, [])

  async function update(id: string, patch: Partial<Lead>) {
    setLeads(ls => ls.map(l => l.id === id ? { ...l, ...patch } : l))
    await supabase.from('leads').update(patch).eq('id', id)
  }
  async function addLead(e: React.FormEvent) {
    e.preventDefault()
    if (!form.company_name && !form.email) return
    const { data } = await supabase.from('leads').insert({ ...form, status: 'nouveau', source: 'manuel' }).select().single()
    if (data) setLeads(ls => [data as any, ...ls])
    setForm({ company_name: '', contact_name: '', email: '', phone: '' })
  }

  const filtered = leads.filter(l =>
    !q || [l.company_name, l.contact_name, l.email, l.city, l.industry].some(x => (x || '').toLowerCase().includes(q.toLowerCase())))

  const input = 'bg-black/30 border border-white/10 rounded px-3 py-2 text-sm focus:border-orange outline-none'

  return (
    <Layout title="CRM / Leads">
      <a href="/admin" className="text-xs uppercase tracking-widest text-acier hover:text-orange">← Admin</a>

      <form onSubmit={addLead} className="flex flex-wrap gap-2 mt-6 mb-6">
        <input className={input} placeholder="Entreprise" value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} />
        <input className={input} placeholder="Contact" value={form.contact_name} onChange={e => setForm({ ...form, contact_name: e.target.value })} />
        <input className={input} placeholder="Courriel" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
        <input className={input} placeholder="Téléphone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
        <button className="bg-orange hover:bg-orange-hover px-5 rounded-sm text-sm font-bold uppercase tracking-wider">+ Ajouter</button>
      </form>

      <input className={input + ' w-full mb-4'} placeholder="Rechercher…" value={q} onChange={e => setQ(e.target.value)} />

      {loading ? <p className="text-acier">Chargement…</p> : (
        <div className="border border-white/10 rounded overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-white/5 text-acier text-[11px] uppercase tracking-widest">
              <tr>
                <th className="text-left px-3 py-3">Entreprise</th>
                <th className="text-left px-3 py-3">Contact</th>
                <th className="text-left px-3 py-3">Courriel</th>
                <th className="text-left px-3 py-3">Ville</th>
                <th className="text-center px-3 py-3">Score</th>
                <th className="text-left px-3 py-3">Statut</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(l => (
                <tr key={l.id} className="border-t border-white/5 hover:bg-white/[0.03]">
                  <td className="px-3 py-2 font-medium">{l.company_name || '—'}<div className="text-acier text-xs">{l.industry}</div></td>
                  <td className="px-3 py-2">{l.contact_name || '—'}<div className="text-acier text-xs">{l.contact_title}</div></td>
                  <td className="px-3 py-2 text-acier">{l.email || '—'}</td>
                  <td className="px-3 py-2 text-acier">{l.city || '—'}</td>
                  <td className="px-3 py-2 text-center">
                    <input type="number" className={input + ' w-16 text-center'} value={l.score ?? 0}
                      onChange={e => update(l.id, { score: +e.target.value })} />
                  </td>
                  <td className="px-3 py-2">
                    <select className={input} value={l.status || 'nouveau'} onChange={e => update(l.id, { status: e.target.value })}>
                      {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                      {l.status && !STATUSES.includes(l.status) && <option value={l.status}>{l.status}</option>}
                    </select>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={6} className="px-3 py-6 text-center text-acier">Aucun lead. Ajoutez-en un ci-dessus.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  )
}
